import { useRef } from "react";
import { useFrame } from "@react-three/fiber";
import * as THREE from "three";
import { gameState } from "./gameStore";

const OFFSET = new THREE.Vector3(0, 6.5, 12);
const tmpVec = new THREE.Vector3();
const desiredPos = new THREE.Vector3();
const lookTarget = new THREE.Vector3();
const UP = new THREE.Vector3(0, 1, 0);

// Pure follow-camera: position + rotation are derived ONLY from the
// character's own heading and position (gameState). No mouse or other input
// moves the camera independently — it simply trails the character, smoothly.
export default function ThirdPersonCameraRig() {
  const smoothedLook = useRef(new THREE.Vector3(0, 1.2, 15));

  useFrame(({ camera }, delta) => {
    tmpVec.copy(OFFSET).applyAxisAngle(UP, gameState.facing);
    desiredPos.copy(gameState.position).add(tmpVec);

    const damp = 1 - Math.pow(0.0001, delta);
    camera.position.lerp(desiredPos, Math.min(damp, 1));

    lookTarget.copy(gameState.position).add(new THREE.Vector3(0, 1.3, 0));
    smoothedLook.current.lerp(lookTarget, Math.min(damp * 1.4, 1));
    camera.lookAt(smoothedLook.current);
  });

  return null;
}
